import { Button } from "antd";
import classNames from "classnames";
import { shortenValue, toastMessage, useGlobalMerchant } from "utils/helper";
import { useStyles } from './style';

const ECAShippingComponent = ({
  itemList,
  grandTotal,
  onCheckout,
  onBtnLoader,
  googleReCaptchaProps
}: any) => {
  const classes = useStyles();
  const { globalMerchantCurrency } = useGlobalMerchant();

  return (
    <div className={classNames(classes.ecShippingWrapper)}>
      <p className="subHeading">Your Order</p>
      <div className="ecFlexSpaceWrapper ShippingHeading">
        <span className="subInnerHeading">Product</span>
        <span className="subInnerHeading">Subtotal</span>
      </div>
      {itemList.map((items: any) => (
        <div key={items.product.product_id} className="ecFlexSpaceWrapper">
          <span className="subInnerHeadingPara">
            {items.product.product_name}
          </span>
          <span className="subInnerHeading">
            {shortenValue(items.qty * items.product.price)} {globalMerchantCurrency}
          </span>
        </div>
      ))}
      <div className="ecFlexSpaceWrapper ShippingCost">
        <p className="subHeadingPara">Total</p>
        <p className="subHeading m0">{shortenValue(grandTotal)} {globalMerchantCurrency}</p>
      </div>
      <p className="subInnerHeadingPara ecShippingInfo">
        When placing an order, we ask for your email and phone number (both
        optional) as well as your address (required for delivery). This
        information is used solely to process your order.
      </p>
      <Button
        type="primary"
        className="commonButton"
        onClick={() => onCheckout()}
        disabled={grandTotal === 0}
      >
        {onBtnLoader ? "Loading..." : "Place Order"}
      </Button>
    </div>
  );
};

export default ECAShippingComponent;
